import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/Herosection";
import AdsSection from "../components/AdsSection";
import Categories from "../components/Categories";
import HowItWorks from "../components/HowItWorks";
import PopularServices from "../components/PopularServices";
import TrendingSearches from "../components/TrendingSearches";
import CustomerReviews from "../components/CustomerReviews";
import Footer from "../components/Footer";
import LoginPopup from "../components/LoginPopup";


function Home() {
    return (
        <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#fff" }}>

            <Navbar />
            <HeroSection />
            <br></br>
            <AdsSection />
            <Categories />
            <HowItWorks />
            <PopularServices />
            <TrendingSearches />
            <CustomerReviews />
            <br></br>
            <br></br>
            <br></br>
            <Footer />

        </div>
    );
}

export default Home;
